import React from 'react';
import { NoteSvg } from '../svg';
import SplitText from "../../../common/SplitText";

const banner = process.env.PUBLIC_URL + '/images/investment.webp';

export default function Investment() {
    const [position, setPosition] = React.useState(window.innerWidth <= 645);
        
        React.useEffect(() => {
            window.onresize = function () {
                setPosition(window.innerWidth <= 645);
            };
        }, []);
  return (
    <div className='mt-[100px] relative px-[16px] sm:px-0 w-full sm:w-11/12 max-w-[1360px] mx-auto grid lg:grid-cols-2 gap-[40px] lg:gap-[60px] justify-between items-center'>
        <div>
            <SplitText
                text="Investment and Returns"
                tag="h2"
                className='text-[#181F38] text-[28px] sm:text-[40px] lg:text-[48px] xl:text-[56px] font-bold'
                delay={30}
                duration={0.6}
                ease="power3.out"
                splitType="words, chars"
                from={{ opacity: 0, y: 30 }}
                to={{ opacity: 1, y: 0 }}
                threshold={0.1}
                rootMargin="-40px"
                textAlign="left"
            />
            <div className='mt-[24px] sm:mt-[36px] bg-white p-[24px] sm:p-[36px] rounded-[28px] border border-gray-100 shadow-card'>
                <div className='flex gap-[16px] items-center'>
                    <div className='size-[42px] sm:size-[52px] flex items-center justify-center bg-[#34C759] text-white rounded-[14px] shadow-sm'>
                        <NoteSvg size={position ? "22" : "28"}/>
                    </div>
                    <div>
                        <h3 className='text-[#181F38] text-[20px] sm:text-[24px] font-bold'>Franchise Fees & Structure</h3>
                        <p className='text-[#64748B] text-[13px] sm:text-[15px]'>Clear, transparent one-time initial investment</p>
                    </div>
                </div>
                
                <div className='mt-[24px] flex flex-col gap-[12px]'>
                    <div className='flex justify-between items-center p-[14px] sm:p-[16px] bg-[#F8FAFC] rounded-[16px] border border-gray-100'>
                        <div className='flex items-center gap-[10px] font-semibold text-[#181F38] text-[15px] sm:text-[17px]'>
                            <span className='size-2 rounded-full bg-[#FA8CA6]'></span>
                            <span>Premium Cart</span>
                        </div>
                        <span className='font-bold text-[#181F38] text-[16px] sm:text-[18px]'>₹10 Lakhs</span>
                    </div>

                    <div className='flex justify-between items-center p-[14px] sm:p-[16px] bg-[#F8FAFC] rounded-[16px] border border-gray-100'>
                        <div className='flex items-center gap-[10px] font-semibold text-[#181F38] text-[15px] sm:text-[17px]'>
                            <span className='size-2 rounded-full bg-[#A880FF]'></span>
                            <span>Mid-Range Cart</span>
                        </div>
                        <span className='font-bold text-[#181F38] text-[16px] sm:text-[18px]'>₹5 Lakhs</span>
                    </div>

                    <div className='flex justify-between items-center p-[14px] sm:p-[16px] bg-[#F8FAFC] rounded-[16px] border border-gray-100'>
                        <div className='flex items-center gap-[10px] font-semibold text-[#181F38] text-[15px] sm:text-[17px]'>
                            <span className='size-2 rounded-full bg-[#FF4E99]'></span>
                            <span>Economy Cart</span>
                        </div>
                        <span className='font-bold text-[#181F38] text-[16px] sm:text-[18px]'>₹3 Lakhs</span>
                    </div>
                </div>

                <div className='mt-[20px] pt-[20px] border-t border-gray-100 flex flex-wrap items-center justify-between gap-[10px]'>
                    <span className='inline-flex items-center gap-[6px] bg-emerald-50 border border-emerald-200/70 text-emerald-800 font-bold px-[14px] py-[6px] rounded-full text-[13px]'>
                        ✓ 0% Ongoing Royalty
                    </span>
                    <span className='text-[#64748B] text-[13px] sm:text-[14px]'>
                        Stock purchased directly at wholesale rates
                    </span>
                </div>
            </div>
        </div>
        <div className='flex justify-center'>
            <img src={banner} alt='banner' className='w-full max-w-[500px] object-contain drop-shadow-xl' loading='lazy'/>
        </div>
    </div>
  )
}
